module.exports = __webpack_public_path__ + "enigio.b52640e684e0e0e7213e.svg";